const __request = require(`./__request/__request_contentType_json`);

// 新增广告信息：http://tour-beta.yinzhilv.com/doc.html#/yinzhilv_travel/advert-controller/addUsingPOST
const web_common_advert_add = (pParameter) => {
    if (!pParameter) pParameter = {};
    const p = {
        method: 'post',
        urlSuffix: '/web/common/advert/add',
        data: pParameter
    };
    return new Promise(function(resolve, reject) {
        resolve(__request(p))
    })
};
module.exports = web_common_advert_add;